"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetIdentityRegisterTips = exports.DeductManagementFee = exports.SendManagementFeeNotice = exports.CreatePayPassword = exports.CheckPhoneOauthToken = exports.MsitePreRegister = exports.GetRegisterVoucher = exports.SendVerifyToken = exports.Unblock = exports.Block = exports.SyncOAuth = exports.InnerSync = exports.InvitationCode = exports.InvitationSummary = exports.AdmGradeList = exports.AdmGradeLog = exports.AdmUpdateGrade = exports.AdmForceLogin = exports.AdmDeleteRemark = exports.AdmAddRemark = exports.AdmRemarks = exports.AdmBlockLog = exports.AdmUnblock = exports.AdmBlock = exports.AdmUpdate = exports.AdmGetByNickName = exports.AdmGet = exports.AdmList = exports.RPCUpdate = exports.RPCGet = exports.SyncUserSession = exports.FetchUserSession = exports.SendCaptcha = exports.RPCLogout = exports.Logout = exports.RPCUpdateDevice = exports.UpdateDevice = exports.CheckSession = exports.IsBlocked = exports.GetSetting = exports.UpdateSetting = exports.UpdateProfile = exports.CheckPassword = exports.ResetPassword = exports.CanUpdatePhone = exports.CanResetPassword = exports.UpdatePassword = exports.ChangePassword = exports.ForgetPassword = exports.BelongBrunei = exports.OAuthXBind = exports.OAuthBind = exports.BruneiOAuthLogin = exports.OAuthLogin = exports.Login = exports.RegisterWithInvitation = exports.RegisterWithPhone = exports.BruneiRegister = exports.Register = exports.PreRegister = exports.NeedPhone = exports.GetUserRegisterDay = exports.GetCustomerInfo = exports.VerifyType = exports.PlatformType = exports.Code = exports.Sex = exports.RegisterChannel = exports.OAuthType = exports.RegisterSource = exports.SendType = exports.SafetyCheck = exports.CheckPwdType = void 0;
var webapi_1 = require("../webapi");
var CheckPwdType;
(function (CheckPwdType) {
    CheckPwdType["CheckPwdTypeWithdraw"] = "CheckPwdTypeWithdraw";
    CheckPwdType["CheckPwdTypePay"] = "CheckPwdTypePay";
})(CheckPwdType = exports.CheckPwdType || (exports.CheckPwdType = {}));
var SafetyCheck;
(function (SafetyCheck) {
    SafetyCheck["SafetyCheckNothing"] = "SafetyCheckNothing";
    SafetyCheck["SafetyCheckSlider"] = "SafetyCheckSlider";
})(SafetyCheck = exports.SafetyCheck || (exports.SafetyCheck = {}));
var SendType;
(function (SendType) {
    SendType["SendTypeRegister"] = "SendTypeRegister";
    SendType["SendTypeUpdatePhone"] = "SendTypeUpdatePhone";
    SendType["SendTypeCreatePayPwd"] = "SendTypeCreatePayPwd";
})(SendType = exports.SendType || (exports.SendType = {}));
var RegisterSource;
(function (RegisterSource) {
    RegisterSource["RegisterSourceNormal"] = "RegisterSourceNormal";
})(RegisterSource = exports.RegisterSource || (exports.RegisterSource = {}));
var OAuthType;
(function (OAuthType) {
    OAuthType["OAuthTypeNone"] = "OAuthTypeNone";
    OAuthType["OAuthTypeGoogle"] = "OAuthTypeGoogle";
    OAuthType["OAuthTypeFacebook"] = "OAuthTypeFacebook";
})(OAuthType = exports.OAuthType || (exports.OAuthType = {}));
var RegisterChannel;
(function (RegisterChannel) {
    RegisterChannel["RegisterChannelTypeNormal"] = "RegisterChannelTypeNormal";
    RegisterChannel["RegisterChannelTypeGoogle"] = "RegisterChannelTypeGoogle";
    RegisterChannel["RegisterChannelTypeFacebook"] = "RegisterChannelTypeFacebook";
})(RegisterChannel = exports.RegisterChannel || (exports.RegisterChannel = {}));
var Sex;
(function (Sex) {
    Sex["SexNone"] = "SexNone";
    Sex["SexFemale"] = "SexFemale";
    Sex["SexMale"] = "SexMale";
})(Sex = exports.Sex || (exports.Sex = {}));
var Code;
(function (Code) {
    Code["CodeOk"] = "CodeOk";
    Code["CodeErr"] = "CodeErr";
    Code["CodeNotFound"] = "CodeNotFound";
    Code["CodeForbidden"] = "CodeForbidden";
    Code["CodeLoginFail"] = "CodeLoginFail";
    Code["CodeExistsEmail"] = "CodeExistsEmail";
    Code["CodeExistsNickname"] = "CodeExistsNickname";
    Code["CodeExistsPhone"] = "CodeExistsPhone";
    Code["CodeInvalidRegion"] = "CodeInvalidRegion";
    Code["CodeInvalidNickname"] = "CodeInvalidNickname";
    Code["CodeInvalidEmail"] = "CodeInvalidEmail";
    Code["CodeInvalidPassword"] = "CodeInvalidPassword";
    Code["CodeInvalidPhone"] = "CodeInvalidPhone";
    Code["CodeInvalidOAuthType"] = "CodeInvalidOAuthType";
    Code["CodeInvalidToken"] = "CodeInvalidToken";
    Code["CodeInvalidCaptcha"] = "CodeInvalidCaptcha";
    Code["CodeUnmatchedPassword"] = "CodeUnmatchedPassword";
    Code["CodeUnmatchedEmail"] = "CodeUnmatchedEmail";
    Code["CodeBlocked"] = "CodeBlocked";
    Code["CodeNeedPhone"] = "CodeNeedPhone";
    Code["CodeOverLimitSendCaptcha"] = "CodeOverLimitSendCaptcha";
    Code["CodeShouldLinkFacebook"] = "CodeShouldLinkFacebook";
    Code["CodeShouldLinkGoogle"] = "CodeShouldLinkGoogle";
    Code["CodeCustomerCreatedByFacebook"] = "CodeCustomerCreatedByFacebook";
    Code["CodeCustomerCreatedByGoogle"] = "CodeCustomerCreatedByGoogle";
    Code["CodeCustomerInfoError"] = "CodeCustomerInfoError";
    Code["CodeNotExistsTelphone"] = "CodeNotExistsTelphone";
    Code["CodeInvalidCatalog"] = "CodeInvalidCatalog";
    Code["CodeSendCaptchaError"] = "CodeSendCaptchaError";
    Code["CodeSendEamilError"] = "CodeSendEamilError";
    Code["CodeVerityTypeError"] = "CodeVerityTypeError";
    Code["CodeGetTokenError"] = "CodeGetTokenError";
    Code["CodeCaptchaMaxError"] = "CodeCaptchaMaxError";
    Code["CodeSamePhoneNumber"] = "CodeSamePhoneNumber";
    Code["CodeInputNewPhoneNumber"] = "CodeInputNewPhoneNumber";
    Code["CodeNeedCreatePayPwd"] = "CodeNeedCreatePayPwd";
    Code["CodeCheckPayPwdMaxError"] = "CodeCheckPayPwdMaxError";
    Code["CodeCheckLoginPwdMaxError"] = "CodeCheckLoginPwdMaxError";
    Code["CodeSendCaptchTypeError"] = "CodeSendCaptchTypeError";
    Code["CodePayPwdSameAsPwd"] = "CodePayPwdSameAsPwd";
    Code["CodeCantCreatePayPwd"] = "CodeCantCreatePayPwd";
    Code["CodeUnmatchedPayPassword"] = "CodeUnmatchedPayPassword";
    Code["CodeUnmatchedLoginPassword"] = "CodeUnmatchedLoginPassword";
})(Code = exports.Code || (exports.Code = {}));
var PlatformType;
(function (PlatformType) {
    PlatformType["NULL"] = "NULL";
    PlatformType["OldSite"] = "OldSite";
    PlatformType["iPhone"] = "iPhone";
    PlatformType["Andriod"] = "Andriod";
    PlatformType["iPad"] = "iPad";
    PlatformType["Website"] = "Website";
    PlatformType["BackOffice"] = "BackOffice";
    PlatformType["MobileWeb"] = "MobileWeb";
    PlatformType["EZCart"] = "EZCart";
})(PlatformType = exports.PlatformType || (exports.PlatformType = {}));
var VerifyType;
(function (VerifyType) {
    VerifyType["VerifyTypeNull"] = "VerifyTypeNull";
    VerifyType["VerifyTypePhone"] = "VerifyTypePhone";
    VerifyType["VerifyTypeEmail"] = "VerifyTypeEmail";
})(VerifyType = exports.VerifyType || (exports.VerifyType = {}));
function GetCustomerInfo(payload) {
    return webapi_1.default("nadesico.Customer/GetCustomerInfo", payload);
}
exports.GetCustomerInfo = GetCustomerInfo;
function GetUserRegisterDay(payload) {
    return webapi_1.default("nadesico.Customer/GetUserRegisterDay", payload);
}
exports.GetUserRegisterDay = GetUserRegisterDay;
function NeedPhone(payload) {
    return webapi_1.default("nadesico.Customer/NeedPhone", payload);
}
exports.NeedPhone = NeedPhone;
function PreRegister(payload) {
    return webapi_1.default("nadesico.Customer/PreRegister", payload);
}
exports.PreRegister = PreRegister;
function Register(payload) {
    return webapi_1.default("nadesico.Customer/Register", payload);
}
exports.Register = Register;
function BruneiRegister(payload) {
    return webapi_1.default("nadesico.Customer/BruneiRegister", payload);
}
exports.BruneiRegister = BruneiRegister;
function RegisterWithPhone(payload) {
    return webapi_1.default("nadesico.Customer/RegisterWithPhone", payload);
}
exports.RegisterWithPhone = RegisterWithPhone;
function RegisterWithInvitation(payload) {
    return webapi_1.default("nadesico.Customer/RegisterWithInvitation", payload);
}
exports.RegisterWithInvitation = RegisterWithInvitation;
function Login(payload) {
    return webapi_1.default("nadesico.Customer/Login", payload);
}
exports.Login = Login;
function OAuthLogin(payload) {
    return webapi_1.default("nadesico.Customer/OAuthLogin", payload);
}
exports.OAuthLogin = OAuthLogin;
function BruneiOAuthLogin(payload) {
    return webapi_1.default("nadesico.Customer/BruneiOAuthLogin", payload);
}
exports.BruneiOAuthLogin = BruneiOAuthLogin;
function OAuthBind(payload) {
    return webapi_1.default("nadesico.Customer/OAuthBind", payload);
}
exports.OAuthBind = OAuthBind;
function OAuthXBind(payload) {
    return webapi_1.default("nadesico.Customer/OAuthXBind", payload);
}
exports.OAuthXBind = OAuthXBind;
function BelongBrunei(payload) {
    return webapi_1.default("nadesico.Customer/BelongBrunei", payload);
}
exports.BelongBrunei = BelongBrunei;
function ForgetPassword(payload) {
    return webapi_1.default("nadesico.Customer/ForgetPassword", payload);
}
exports.ForgetPassword = ForgetPassword;
function ChangePassword(payload) {
    return webapi_1.default("nadesico.Customer/ChangePassword", payload);
}
exports.ChangePassword = ChangePassword;
function UpdatePassword(payload) {
    return webapi_1.default("nadesico.Customer/UpdatePassword", payload);
}
exports.UpdatePassword = UpdatePassword;
function CanResetPassword(payload) {
    return webapi_1.default("nadesico.Customer/CanResetPassword", payload);
}
exports.CanResetPassword = CanResetPassword;
function CanUpdatePhone(payload) {
    return webapi_1.default("nadesico.Customer/CanUpdatePhone", payload);
}
exports.CanUpdatePhone = CanUpdatePhone;
function ResetPassword(payload) {
    return webapi_1.default("nadesico.Customer/ResetPassword", payload);
}
exports.ResetPassword = ResetPassword;
function CheckPassword(payload) {
    return webapi_1.default("nadesico.Customer/CheckPassword", payload);
}
exports.CheckPassword = CheckPassword;
function UpdateProfile(payload) {
    return webapi_1.default("nadesico.Customer/UpdateProfile", payload);
}
exports.UpdateProfile = UpdateProfile;
function UpdateSetting(payload) {
    return webapi_1.default("nadesico.Customer/UpdateSetting", payload);
}
exports.UpdateSetting = UpdateSetting;
function GetSetting(payload) {
    return webapi_1.default("nadesico.Customer/GetSetting", payload);
}
exports.GetSetting = GetSetting;
function IsBlocked(payload) {
    return webapi_1.default("nadesico.Customer/IsBlocked", payload);
}
exports.IsBlocked = IsBlocked;
function CheckSession(payload) {
    return webapi_1.default("nadesico.Customer/CheckSession", payload);
}
exports.CheckSession = CheckSession;
function UpdateDevice(payload) {
    return webapi_1.default("nadesico.Customer/UpdateDevice", payload);
}
exports.UpdateDevice = UpdateDevice;
function RPCUpdateDevice(payload) {
    return webapi_1.default("nadesico.Customer/RPCUpdateDevice", payload);
}
exports.RPCUpdateDevice = RPCUpdateDevice;
function Logout(payload) {
    return webapi_1.default("nadesico.Customer/Logout", payload);
}
exports.Logout = Logout;
function RPCLogout(payload) {
    return webapi_1.default("nadesico.Customer/RPCLogout", payload);
}
exports.RPCLogout = RPCLogout;
function SendCaptcha(payload) {
    return webapi_1.default("nadesico.Customer/SendCaptcha", payload);
}
exports.SendCaptcha = SendCaptcha;
function FetchUserSession(payload) {
    return webapi_1.default("nadesico.Customer/FetchUserSession", payload);
}
exports.FetchUserSession = FetchUserSession;
function SyncUserSession(payload) {
    return webapi_1.default("nadesico.Customer/SyncUserSession", payload);
}
exports.SyncUserSession = SyncUserSession;
function RPCGet(payload) {
    return webapi_1.default("nadesico.Customer/RPCGet", payload);
}
exports.RPCGet = RPCGet;
function RPCUpdate(payload) {
    return webapi_1.default("nadesico.Customer/RPCUpdate", payload);
}
exports.RPCUpdate = RPCUpdate;
function AdmList(payload) {
    return webapi_1.default("nadesico.Customer/AdmList", payload);
}
exports.AdmList = AdmList;
function AdmGet(payload) {
    return webapi_1.default("nadesico.Customer/AdmGet", payload);
}
exports.AdmGet = AdmGet;
function AdmGetByNickName(payload) {
    return webapi_1.default("nadesico.Customer/AdmGetByNickName", payload);
}
exports.AdmGetByNickName = AdmGetByNickName;
function AdmUpdate(payload) {
    return webapi_1.default("nadesico.Customer/AdmUpdate", payload);
}
exports.AdmUpdate = AdmUpdate;
function AdmBlock(payload) {
    return webapi_1.default("nadesico.Customer/AdmBlock", payload);
}
exports.AdmBlock = AdmBlock;
function AdmUnblock(payload) {
    return webapi_1.default("nadesico.Customer/AdmUnblock", payload);
}
exports.AdmUnblock = AdmUnblock;
function AdmBlockLog(payload) {
    return webapi_1.default("nadesico.Customer/AdmBlockLog", payload);
}
exports.AdmBlockLog = AdmBlockLog;
function AdmRemarks(payload) {
    return webapi_1.default("nadesico.Customer/AdmRemarks", payload);
}
exports.AdmRemarks = AdmRemarks;
function AdmAddRemark(payload) {
    return webapi_1.default("nadesico.Customer/AdmAddRemark", payload);
}
exports.AdmAddRemark = AdmAddRemark;
function AdmDeleteRemark(payload) {
    return webapi_1.default("nadesico.Customer/AdmDeleteRemark", payload);
}
exports.AdmDeleteRemark = AdmDeleteRemark;
function AdmForceLogin(payload) {
    return webapi_1.default("nadesico.Customer/AdmForceLogin", payload);
}
exports.AdmForceLogin = AdmForceLogin;
function AdmUpdateGrade(payload) {
    return webapi_1.default("nadesico.Customer/AdmUpdateGrade", payload);
}
exports.AdmUpdateGrade = AdmUpdateGrade;
function AdmGradeLog(payload) {
    return webapi_1.default("nadesico.Customer/AdmGradeLog", payload);
}
exports.AdmGradeLog = AdmGradeLog;
function AdmGradeList(payload) {
    return webapi_1.default("nadesico.Customer/AdmGradeList", payload);
}
exports.AdmGradeList = AdmGradeList;
function InvitationSummary(payload) {
    return webapi_1.default("nadesico.Customer/InvitationSummary", payload);
}
exports.InvitationSummary = InvitationSummary;
function InvitationCode(payload) {
    return webapi_1.default("nadesico.Customer/InvitationCode", payload);
}
exports.InvitationCode = InvitationCode;
function InnerSync(payload) {
    return webapi_1.default("nadesico.Customer/InnerSync", payload);
}
exports.InnerSync = InnerSync;
function SyncOAuth(payload) {
    return webapi_1.default("nadesico.Customer/SyncOAuth", payload);
}
exports.SyncOAuth = SyncOAuth;
function Block(payload) {
    return webapi_1.default("nadesico.Customer/Block", payload);
}
exports.Block = Block;
function Unblock(payload) {
    return webapi_1.default("nadesico.Customer/Unblock", payload);
}
exports.Unblock = Unblock;
function SendVerifyToken(payload) {
    return webapi_1.default("nadesico.Customer/SendVerifyToken", payload);
}
exports.SendVerifyToken = SendVerifyToken;
function GetRegisterVoucher(payload) {
    return webapi_1.default("nadesico.Customer/GetRegisterVoucher", payload);
}
exports.GetRegisterVoucher = GetRegisterVoucher;
function MsitePreRegister(payload) {
    return webapi_1.default("nadesico.Customer/MsitePreRegister", payload);
}
exports.MsitePreRegister = MsitePreRegister;
function CheckPhoneOauthToken(payload) {
    return webapi_1.default("nadesico.Customer/CheckPhoneOauthToken", payload);
}
exports.CheckPhoneOauthToken = CheckPhoneOauthToken;
function CreatePayPassword(payload) {
    return webapi_1.default("nadesico.Customer/CreatePayPassword", payload);
}
exports.CreatePayPassword = CreatePayPassword;
function SendManagementFeeNotice(payload) {
    return webapi_1.default("nadesico.Customer/SendManagementFeeNotice", payload);
}
exports.SendManagementFeeNotice = SendManagementFeeNotice;
function DeductManagementFee(payload) {
    return webapi_1.default("nadesico.Customer/DeductManagementFee", payload);
}
exports.DeductManagementFee = DeductManagementFee;
function GetIdentityRegisterTips(payload) {
    return webapi_1.default("nadesico.Customer/GetIdentityRegisterTips", payload);
}
exports.GetIdentityRegisterTips = GetIdentityRegisterTips;
exports.default = {
    GetCustomerInfo: GetCustomerInfo,
    GetUserRegisterDay: GetUserRegisterDay,
    NeedPhone: NeedPhone,
    PreRegister: PreRegister,
    Register: Register,
    BruneiRegister: BruneiRegister,
    RegisterWithPhone: RegisterWithPhone,
    RegisterWithInvitation: RegisterWithInvitation,
    Login: Login,
    OAuthLogin: OAuthLogin,
    BruneiOAuthLogin: BruneiOAuthLogin,
    OAuthBind: OAuthBind,
    OAuthXBind: OAuthXBind,
    BelongBrunei: BelongBrunei,
    ForgetPassword: ForgetPassword,
    ChangePassword: ChangePassword,
    UpdatePassword: UpdatePassword,
    CanResetPassword: CanResetPassword,
    CanUpdatePhone: CanUpdatePhone,
    ResetPassword: ResetPassword,
    CheckPassword: CheckPassword,
    UpdateProfile: UpdateProfile,
    UpdateSetting: UpdateSetting,
    GetSetting: GetSetting,
    IsBlocked: IsBlocked,
    CheckSession: CheckSession,
    UpdateDevice: UpdateDevice,
    RPCUpdateDevice: RPCUpdateDevice,
    Logout: Logout,
    RPCLogout: RPCLogout,
    SendCaptcha: SendCaptcha,
    FetchUserSession: FetchUserSession,
    SyncUserSession: SyncUserSession,
    RPCGet: RPCGet,
    RPCUpdate: RPCUpdate,
    AdmList: AdmList,
    AdmGet: AdmGet,
    AdmGetByNickName: AdmGetByNickName,
    AdmUpdate: AdmUpdate,
    AdmBlock: AdmBlock,
    AdmUnblock: AdmUnblock,
    AdmBlockLog: AdmBlockLog,
    AdmRemarks: AdmRemarks,
    AdmAddRemark: AdmAddRemark,
    AdmDeleteRemark: AdmDeleteRemark,
    AdmForceLogin: AdmForceLogin,
    AdmUpdateGrade: AdmUpdateGrade,
    AdmGradeLog: AdmGradeLog,
    AdmGradeList: AdmGradeList,
    InvitationSummary: InvitationSummary,
    InvitationCode: InvitationCode,
    InnerSync: InnerSync,
    SyncOAuth: SyncOAuth,
    Block: Block,
    Unblock: Unblock,
    SendVerifyToken: SendVerifyToken,
    GetRegisterVoucher: GetRegisterVoucher,
    MsitePreRegister: MsitePreRegister,
    CheckPhoneOauthToken: CheckPhoneOauthToken,
    CreatePayPassword: CreatePayPassword,
    SendManagementFeeNotice: SendManagementFeeNotice,
    DeductManagementFee: DeductManagementFee,
    GetIdentityRegisterTips: GetIdentityRegisterTips,
};
